import { PayloadAction } from '@reduxjs/toolkit';

import { ICompany } from '../../auth/interfaces/ICompany';

export const CompanyReducer = {
	setCompany: (state: ICompany, action: PayloadAction<ICompany>) => {
		state.legal_name = action.payload.legal_name;
		state.user_kam = action.payload.user_kam;
		state.owner_email = action.payload.owner_email;
		state.payment_email = action.payload.payment_email;
	},

	setPaymentEmail: (state: ICompany, action: PayloadAction<string>) => {
		state.payment_email = action.payload;
	},
};
